import React, { Dispatch, SetStateAction } from "react";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import {
    DeletarRespostasEnviadasFormularioProdutoController,
    ObterFormularioProdutoController,
    ResponderFormularioProdutoController,
} from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import UnForm from "../../../../../Components/Form";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { IResponderFormularioProduto } from "../../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import { useUserInfor } from "../../../../../Context/User";

interface IRespondeFormularioProdutoProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    ID_EMPREENDIMENTO: number;
    updateList: () => void;
}

export default function RespondeFormularioProduto(
    props: IRespondeFormularioProdutoProps
) {
    const { UserInfor } = useUserInfor();

    const {
        value: lstFormularioProduto,
        loading: lstFormularioProdutoLoading,
        // execute: updateList
    } = useAsyncEffect(() =>
        ObterFormularioProdutoController(props.ID_EMPREENDIMENTO, true)
    );

    const {
        execute: ResponderFormularioProduto,
        loading: ResponderFormularioProdutoLoading,
    } = useAsyncCallback(ResponderFormularioProdutoController);

    const {
        execute: DeletarRespostasEnviadasFormularioProduto,
        loading: DeletarRespostasEnviadasFormularioProdutoLoading,
    } = useAsyncCallback(DeletarRespostasEnviadasFormularioProdutoController);

    function handleResponderFormularioProduto(
        formData: Array<IResponderFormularioProduto>
    ) {
        const formDataArray = Object.values(formData).map((item) => ({
            ...item,
        }));

        const verificaRespostaEscolhida =
            lstFormularioProduto?.PERGUNTAS[0]?.RESPOSTA_ESCOLHIDA !== null;

        if (verificaRespostaEscolhida) {
            DeletarRespostasEnviadasFormularioProduto(
                lstFormularioProduto?.ID_FORMULARIO_PRODUTO ?? 0
            ).then(() => {
                ResponderFormularioProduto(formDataArray).then(() => {
                    props.setShow(false);
                    props.updateList();
                });
            });
        } else {
            ResponderFormularioProduto(formDataArray).then(() => {
                props.setShow(false);
                props.updateList();
            });
        }
    }

    return (
        <>
            <OrSpinner spinner="capys" loading={lstFormularioProdutoLoading}>
                <UnForm handleSubmit={handleResponderFormularioProduto}>
                    {lstFormularioProduto?.PERGUNTAS.map((pergunta, index) => (
                        <div key={pergunta.ID_FORMULARIO_PRODUTO_PERGUNTA}>
                            <div className="d-flex align-items-center g-3 ml-8 row">
                                <h4 className="mt-3 mb-4">
                                    {pergunta.DS_PERGUNTA}
                                </h4>
                            </div>

                            <div className="d-flex justify-content-center flex-wrap mb-4">
                                {pergunta.RESPOSTAS?.map((resposta) =>
                                    resposta.DS_RESPOSTA ===
                                    "pergunta_resposta_texto" ? (
                                        <UnForm.Input
                                            readOnly
                                            name={`${index}.ID_FORMULARIO_PRODUTO_RESPOSTA`}
                                            value={
                                                resposta.ID_FORMULARIO_PRODUTO_RESPOSTA
                                            }
                                            style={{
                                                display: "none",
                                            }}
                                            wrapperClassName="d-none"
                                        />
                                    ) : (
                                        <label
                                            key={
                                                resposta.ID_FORMULARIO_PRODUTO_RESPOSTA
                                            }
                                            className="d-flex flex-column align-items-center mb-3 me-3 radio-option"
                                        >
                                            <label>
                                                {resposta.DS_RESPOSTA}
                                            </label>
                                            <UnForm.Input
                                                type="radio"
                                                style={{
                                                    minWidth: "150px",
                                                }}
                                                value={
                                                    resposta.ID_FORMULARIO_PRODUTO_RESPOSTA
                                                }
                                                name={`${index}.ID_FORMULARIO_PRODUTO_RESPOSTA`}
                                                registerOptions={{
                                                    required:
                                                        "Selecione uma opção",
                                                }}
                                            />
                                        </label>
                                    )
                                )}
                            </div>
                            <UnForm.Textarea
                                label="Comentário"
                                name={`${index}.DS_COMENTARIO`}
                                registerOptions={{
                                    required: "Insira um comentário",
                                }}
                            />

                            <UnForm.Input
                                readOnly
                                name={`${index}.ID_USUARIO_RESPOSTA`}
                                value={UserInfor.ID_USUARIO ?? 0}
                                style={{
                                    display: "none",
                                }}
                                wrapperClassName="d-none"
                            />

                            <hr />
                        </div>
                    ))}

                    <UnForm.SubmitButton
                        color="primary"
                        icon={faPaperPlane}
                        className="w-100"
                        disabled={
                            ResponderFormularioProdutoLoading ||
                            DeletarRespostasEnviadasFormularioProdutoLoading
                        }
                        loading={
                            ResponderFormularioProdutoLoading ||
                            DeletarRespostasEnviadasFormularioProdutoLoading
                        }
                    >
                        Enviar
                    </UnForm.SubmitButton>
                </UnForm>
            </OrSpinner>
        </>
    );
}
